var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5278 11.9997C18.5278 12.5301 18.3171 13.0388 17.9421 13.4138C17.567 13.7889 17.0583 13.9996 16.5279 13.9996H9.52808L6.15317 17.9995V14.0621L2.5061 14.0216C1.41026 14.0094 0.52832 13.1176 0.52832 12.0217V1.99995C0.52832 1.46953 0.739028 0.960833 1.11409 0.58577C1.48915 0.210708 1.99785 0 2.52827 0H16.5279C17.0583 0 17.567 0.210708 17.9421 0.58577C18.3171 0.960833 18.5278 1.46953 18.5278 1.99995V11.9997Z",
    fill: "#9764D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 9V5.315H4.705L6.165 7.89V5.315H6.795V9H6.11L4.65 6.425H4.525V9H3.9ZM7.59629 9V5.315H10.1163V5.885H8.22129V6.785H9.95129V7.355H8.22129V8.43H10.1163V9H7.59629ZM11.2602 9L10.4152 5.315H11.0802L11.6702 8.405H11.7902L12.3802 5.315H12.9402L13.5302 8.405H13.6502L14.2402 5.315H14.9052L14.0552 9H13.1102L12.6602 6.675L12.2102 9H11.2602Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewProduct);
export default __webpack_public_path__ + "static/media/newProduct.8c2a2ad4166b35d784ccddc966c11116.svg";
export { ForwardRef as ReactComponent };